import moment from 'moment'

function calcularValorParcelas(totalPagamento, valorEntradaNumber, numeroParcelas) {
  let totalParcelas = numeroParcelas
  if (valorEntradaNumber > 0 && numeroParcelas > 1) {
    totalParcelas = numeroParcelas - 1
  }

  const valorParcelas = (totalPagamento - valorEntradaNumber) / totalParcelas
  const diferenca =
    totalPagamento - valorEntradaNumber - +(valorParcelas.toFixed(2)) * totalParcelas

  return { valorFinalParcelas: valorParcelas, diferenca }
}

export function gerarParcelasPagamento({
  totalPagamento,
  valorEntradaNumber,
  numeroParcelas,
  dataVencimento,
}) {
  const total = Number(totalPagamento) || 0
  const entrada = Number(valorEntradaNumber) || 0
  const parcelasCount = Number(numeroParcelas) || 1
  const vencimento = dataVencimento ? moment(dataVencimento) : moment()

  if (parcelasCount <= 1) {
    return [
      {
        valor: +total.toFixed(2),
        numero: 1,
        dataVencimento: vencimento.toISOString(),
      },
    ]
  }

  const { valorFinalParcelas, diferenca } = calcularValorParcelas(total, entrada, parcelasCount)
  const parcelas = []

  for (let index = 1; index < parcelasCount; index++) {
    const valor =
      index === 1
        ? +(valorFinalParcelas + diferenca).toFixed(2)
        : +valorFinalParcelas.toFixed(2)

    if (entrada > 0 && valor <= 0) {
      continue
    }

    parcelas.push({
      valor,
      numero: index + 1,
      dataVencimento: vencimento.clone().add(index, 'month').toISOString(),
    })
  }

  if (entrada === 0) {
    parcelas.unshift({
      valor: +valorFinalParcelas.toFixed(2),
      numero: 1,
      dataVencimento: vencimento.toISOString(),
    })
  } else {
    parcelas.unshift({
      valor: +entrada.toFixed(2),
      numero: 1,
      dataVencimento: vencimento.toISOString(),
    })
  }

  return parcelas.map((parcela, index) => ({
    ...parcela,
    numero: index + 1,
  }))
}
